import apiFetch from '../apiFetch'

export default function (idOperario, token) {
  return apiFetch({endPoint: `Operario/getCambiarOperarioProcesado`, method: 'POST', body: {idOperario}, token: token})
}
